import { render, staticRenderFns } from "./RuleCustom.vue?vue&type=template&id=13fa0f06&scoped=true"
import script from "./RuleCustom.vue?vue&type=script&lang=js"
export * from "./RuleCustom.vue?vue&type=script&lang=js"
import style0 from "./RuleCustom.vue?vue&type=style&index=0&id=13fa0f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fa0f06",
  null
  
)

export default component.exports